// extracted by mini-css-extract-plugin
export default {"wrapper":"wT-z"};